module.exports = __webpack_public_path__ + "static/media/52.424e9646.jpg";